import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiExclamationTriangle, HiXCircle } from 'react-icons/hi2';

const DynamicModal = ({ isOpen, onClose, type, title, message, onConfirm, confirmText = "Continue" }) => {
  // Configuration for dynamic styling and icons
  const config = {
    error: {
      bg: 'bg-red-100',
      iconColor: 'text-red-600',
      button: 'bg-red-600 hover:bg-red-700',
      icon: <HiXCircle className="w-8 h-8" />,
    },
    warning: {
      bg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      button: 'bg-amber-600 hover:bg-amber-700',
      icon: <HiExclamationTriangle className="w-8 h-8" />,
    },
  };

  const theme = config[type] || config.warning;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop Animation */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm"
          />

          {/* Modal Card Animation */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="relative bg-white rounded-2xl max-w-sm w-full overflow-hidden shadow-2xl"
          >
            <div className="p-6">
              <div className="flex flex-col items-center text-center">
                <div className={`p-3 rounded-full mb-4 ${theme.bg} ${theme.iconColor}`}>
                  {theme.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900">{title}</h3>
                <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                  {message}
                </p>
              </div>
            </div>

            <div className="bg-gray-50 px-6 py-4 flex flex-col gap-2">
              {onConfirm && (
                <button
                  onClick={() => {
                    onConfirm();
                    onClose();
                  }}
                  className={`w-full py-2.5 rounded-xl font-bold text-white transition-all active:scale-95 ${theme.button}`}
                >
                  {confirmText}
                </button>
              )}
              <button
                onClick={onClose}
                className={`w-full py-2.5 rounded-xl font-bold transition-all active:scale-95 ${
                  onConfirm
                    ? "text-gray-600 bg-transparent hover:bg-gray-100"
                    : `text-white ${theme.button}`
                }`}
              >
                {onConfirm ? "Cancel" : "Dismiss"}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DynamicModal;